import { ExperienceMultiToggle } from "PFApp/components/experience_multi_toggle";
import { useExperienceConfig } from "PFApp/hooks/use_experience_config";
import { useExperienceLabelMap } from "PFApp/hooks/use_experience_label_map";
import { Inline } from "PFComponents/containers/flex/inline";
import { ExperienceLevel } from "PFComponents/experience_level";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { Experience } from "PFTypes";
import { useTranslation } from "react-i18next";

import { useCustomValuePreviewContext } from "../../context/custom_value_preview_context";

type ExperienceToggleProps = {
  canEdit?: boolean;
  experience: Experience | null;
  isRequirement: boolean;
  onChange: (value: Experience) => void;
};

export const ExperienceToggle = ({ canEdit, experience, isRequirement, onChange }: ExperienceToggleProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "customValueSidepanel" });
  const { parentChildProfileValues } = useCustomValuePreviewContext();
  const experienceLabelMap = useExperienceLabelMap();
  const { experienceLevels } = useExperienceConfig();

  const hasParentValues = !!parentChildProfileValues?.parentValues?.length;
  const hasChildValues = !!parentChildProfileValues?.childValues?.length;

  if (canEdit) {
    return (
      <ExperienceMultiToggle experience={experience} isRequirement={isRequirement} onChange={onChange} />
    );
  }

  if (experience) {
    return (
      <ReadOnlyField
        label={t("proficiency")}
        value={
          <Inline alignItems="center" gap="spacingSm">
            <ExperienceLevel
              isRequirement={isRequirement && !hasParentValues && !hasChildValues}
              {...{ [isRequirement ? "requiredExperience" : "experience"]: experience }}
              showTooltip={false}
              experienceLevels={experienceLevels}
              experienceLabelMap={experienceLabelMap}
              hasParentValues={hasParentValues}
              hasChildValues={hasChildValues}
            />
            <span>{experienceLabelMap[experience!]}</span>
          </Inline>
        }
      />
    );
  }

  return null;
};
